import * as React from 'react';
import classnames from 'classnames';
import { AppContext } from '@store/context'
import hocContext from '@hoc/context';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import './index.scss';

interface State {
    state1: boolean;
    state2: boolean;
    state3: boolean;
    intro: boolean;
}

interface Props extends AppContext, RouteComponentProps {
    position?: string;
}

class Menu extends React.Component<Props, State> {
    private interval: number;

    constructor(props: Props) {
        super(props);
        this.state = {
            state1: false,
            state2: false,
            state3: false,
            intro: true,
        }
    }

    public componentDidMount() {
        this.interval = window.setTimeout(() => {
            this.setState({intro: false});
        }, 3000)
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.state.state1 && this.state.state2 && !this.props.on && prevProps.on) {
            this.clickHandler(undefined);
        }
    }

    public componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    private clickHandler = (_event?: React.MouseEvent<HTMLDivElement>): void => {
        const state1 = !this.state.state1;

        if (state1) {
            this.setState({state1});
            window.setTimeout(() => {
                this.setState({state2: state1});
            }, 600);
        } else {
            this.setState({state3: true });
            window.setTimeout(() => {
                this.setState({state2: state1, state3: state1});
                window.setTimeout(() => {
                    this.setState({state1});
                }, 600);
            }, 300);
        }
    }

    private menuClick = (link: string, e: React.MouseEvent<HTMLAnchorElement>) => {
        const { history } = this.props;
        e.preventDefault();
        e.stopPropagation();

        window.setTimeout(() => {
            history.push(link);
        }, 1300);

        this.clickHandler();
    }

    render(): JSX.Element {
        const { state1, state2, state3, intro } = this.state;
        const { position, on } = this.props;

        return (
            <React.Fragment>
                {
                    state2 && 
                        <Helmet bodyAttributes={{
                            class: classnames({'menu-open': state2})
                        }}>
                            <style>{'body { overflow: hidden; }'}</style>
                        </Helmet>
                }
                <nav className={classnames('nav-wrapper', {state1, state2, state3})}>
                    <div className="menu">
                        <Link className="a" to="/" onClick={this.menuClick.bind(this, '/')}><span><span data-hover="about me">about me</span></span></Link>
                        <Link className="p" to="/portfolio" onClick={this.menuClick.bind(this, '/portfolio')}><span><span data-hover="portfolio">portfolio</span></span></Link>
                        <Link className="s" to="/skills" onClick={this.menuClick.bind(this, '/skills')}><span><span data-hover="skills">skills</span></span></Link>
                        <Link className="b" to="/blog" onClick={this.menuClick.bind(this, '/blog')}><span><span data-hover="my blog">my blog</span></span></Link>
                        <Link className="c" to="/contact" onClick={this.menuClick.bind(this, '/contact')}><span><span data-hover="contact">contact</span></span></Link>
                    </div>
                </nav>
                <div className={classnames('hamburger-wrapper', position)}>
                    <div className={classnames('hamburger', {
                        intro,
                        out: !on,
                        state1,
                        state2: state2 && !state3
                    })} onClick={this.clickHandler}>
                        <span className="first" />
                        <span className="second" />
                        <span className="third" />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default hocContext(withRouter(Menu));


// WEBPACK FOOTER //
// ./src/components/Menu/index.tsx